/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Following_StatusInputs */

const en_following_status = /** @type {(inputs: Following_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Status: ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Status: {status}" |
*
* @param {Following_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_status = /** @type {((inputs: Following_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_StatusInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_status(inputs)
});